module.exports = __webpack_public_path__ + "img/icon-font-size.d34757c4.svg";